
$(document).ready(function(){
  $('.roll_div').slick({
    dots: true,
    lazyLoad: 'ondemand',
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'ease-in-out',
    prevArrow: false,
    nextArrow: false,
    useTransform: false,
    accessibility: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },

    ],
  });

  $('.main-testimonial').slick({
    dots: true,
    infinite: true,
    lazyLoad: 'ondemand',
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplaySpeed: 5000,
    autoplay: true,
    prevArrow: false,
    nextArrow: false,
      responsive: [
     {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ],
  });
  
  let mp = document.getElementsByClassName("mp-item");
  Array.prototype.forEach.call(mp, function(el) {
    el.classList.remove("invisible");
	});
  
  let test = document.getElementsByClassName("testimony");
  Array.prototype.forEach.call(test, function(el){
    el.classList.remove("invisible");
  });                         
  
});


function swapToOgImage(imgElement) {
  const fullSrc = imgElement.getAttribute('data-second-full-src');
  const ogSrc = imgElement.getAttribute('data-og-src');
  if (!fullSrc.includes( 'no-image')){

  imgElement.src = ogSrc;
}
}
function loadFullImage(imgElement) {
  const preSrc = imgElement.getAttribute('data-second-src');
  const fullSrc = imgElement.getAttribute('data-second-full-src');
  if (fullSrc === null) {
    return;
  }
  if (!fullSrc.includes( 'no-image')){

  const fullImage = new Image();
  imgElement.setAttribute('data-og-src', imgElement.getAttribute('src'));
  imgElement.style.imageRendering = 'pixelated';
  imgElement.src = preSrc;

  fullImage.src = fullSrc;
  fullImage.onload = function() {
    imgElement.style.imageRendering = 'auto';
    imgElement.src = fullSrc;
  };
}
}



function parseResponseData(response) {
  const parsedData = response.map(item => ({
      title: item.title,
      inventoryQuantity: parseInt(item.inventoryQuantity, 10),
      price: parseFloat(item.price),
      descriptionHtml: item.descriptionHtml,
      onlineStoreUrl: item.onlineStoreUrl,
      imageUrl: item.url
  }));

  return parsedData;
}

function getRandomInt(max) {
return Math.floor(Math.random() * max);
}

function replaceProductCards(products) {
  let usedIndices = new Set(); 

  const getNextValidProduct = (products, startIndex) => {
    for (let i = startIndex; i < products.length; i++) {
      if (products[i] && products[i].title && !usedIndices.has(i)) {
        usedIndices.add(i); // Mark this index as used
        return products[i];
      }
    }
    return null;
  };

  const updateProductCard = (imgEl, titleEl, priceEl, containerEl, warrElId, product, fallbackIndex) => {
    if (!product || !product.title) {
      product = getNextValidProduct(products, fallbackIndex);
    }

    if (product) {
      imgEl.src = product['imageUrl'] || '';
      titleEl.innerHTML = product['title'];
      priceEl.innerHTML = '$' + (parseFloat(product['price']) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      containerEl.setAttribute('onclick', `logAndRedirect("${product['onlineStoreUrl'] || '#'}", "trending", "${product['title'] ? product['title'].replace('"', '') : ''}")`);

      if (product['title'] && product['title'].includes('Dell Certified Refurbished')) {
        document.getElementById(warrElId).style.display = 'none';
      }
    }
  };

  if (products.length > 0) {
    const productEls = [
      {
        img: document.getElementById('firstTrendingImage'),
        title: document.getElementById('firstTrendingTitle'),
        price: document.getElementById('firstTrendingPrice'),
        container: document.getElementById('firstTrendingContainer'),
        warrId: 'firstWarr',
        fallback: 1
      },
      {
        img: document.getElementById('secondTrendingImage'),
        title: document.getElementById('secondTrendingTitle'),
        price: document.getElementById('secondTrendingPrice'),
        container: document.getElementById('secondTrendingContainer'),
        warrId: 'secondWarr',
        fallback: 2
      },
      {
        img: document.getElementById('thirdTrendingImage'),
        title: document.getElementById('thirdTrendingTitle'),
        price: document.getElementById('thirdTrendingPrice'),
        container: document.getElementById('thirdTrendingContainer'),
        warrId: 'thirdWarr',
        fallback: 3
      },
      {
        img: document.getElementById('fourthTrendingImage'),
        title: document.getElementById('fourthTrendingTitle'),
        price: document.getElementById('fourthTrendingPrice'),
        container: document.getElementById('fourthTrendingContainer'),
        warrId: 'fourthWarr',
        fallback: 4
      },
      {
        img: document.getElementById('fifthTrendingImage'),
        title: document.getElementById('fifthTrendingTitle'),
        price: document.getElementById('fifthTrendingPrice'),
        container: document.getElementById('fifthTrendingContainer'),
        warrId: 'fifthWarr',
        fallback: 5
      }
    ];

    productEls.forEach((el, index) => {
      const product = products[index] && !usedIndices.has(index) ? products[index] : null;
      usedIndices.add(index); // Mark product as used
      updateProductCard(el.img, el.title, el.price, el.container, el.warrId, product, el.fallback);
    });

    document.querySelectorAll('#SkeletonPlaceholder').forEach(el => el.classList.remove('skeleton_text'));
    document.querySelectorAll('.loading-skeleton').forEach(el => el.classList.remove('loading-skeleton'));
  }
}


async function getPurchasedTogether(sku) {
  const url = `http://api.ombligo.com/getTrending`;

  try {
      const response = await fetch(url);
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const parsedData = JSON.parse(data);
      console.log(parsedData);
      replaceProductCards(parseResponseData(parsedData));
      return parsedData;
  } catch (error) {
      console.error('Error fetching data: ', error);
  }
}


function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function replaceProductTypeCards(type, products) {
    typeMap = {
      'ECC Reg Memory': 'mem',
      'Server Processors': 'proc',
      'Solid State Hard Drive': 'drive'
    
    }
    type = typeMap[type];
    var firstIMG = document.getElementById(type + 'firstTrendingImage');
    var firstTitle = document.getElementById(type + 'firstTrendingTitle');
    var firstPrice = document.getElementById(type + 'firstTrendingPrice');
    var firstContainer = document.getElementById(type + 'firstTrendingContainer');
   // var firstTextContainer = document.getElementById('FirstAlsoBoughtTextContainer');

    var secondIMG = document.getElementById(type + 'secondTrendingImage');
    var secondTitle = document.getElementById(type + 'secondTrendingTitle');
    var secondPrice = document.getElementById(type + 'secondTrendingPrice');
    var secondContainer = document.getElementById(type + 'secondTrendingContainer');
    //var secondTextContainer = document.getElementById('SecondAlsoBoughtTextContainer');

    var thirdIMG = document.getElementById(type + 'thirdTrendingImage');
    var thirdTitle = document.getElementById(type + 'thirdTrendingTitle');
    var thirdPrice = document.getElementById(type + 'thirdTrendingPrice');
    var thirdContainer = document.getElementById(type + 'thirdTrendingContainer');
    //var thirdTextContainer = document.getElementById('ThirdAlsoBoughtTextContainer');

    var fourthIMG = document.getElementById(type + 'fourthTrendingImage');
    var fourthTitle = document.getElementById(type + 'fourthTrendingTitle');
    var fourthPrice = document.getElementById(type + 'fourthTrendingPrice');
    var fourthContainer = document.getElementById(type + 'fourthTrendingContainer');


    var SkeletonPlaceholder =  Array.from(document.querySelectorAll('#SkeletonPlaceholder'));

    if (products.length > 0) {
        p1 = products[0];
        p2 = products[1];
        p3 = products[2];
        p4 = products[3];
        p5 = products[4];


        try{
          firstIMG.src = p1['imageUrl'];
          firstTitle.innerHTML = p1['title'];
          firstPrice.innerHTML = '$' + p1['price'].toFixed(2);
          firstContainer.setAttribute('onclick', 'logAndRedirect("' + p1['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p1['title'].replace('"','') +'")');
        }
        catch(err){
         // console.log(err);
        }
       // firstContainer.classList.remove('loading-skeleton');
       // firstTextContainer.classList.remove('loading-skeleton');
        try{
          secondIMG.src = p2['imageUrl'];
          secondTitle.innerHTML = p2['title'];
          secondPrice.innerHTML = '$' + p2['price'].toFixed(2);
          secondContainer.setAttribute('onclick', 'logAndRedirect("' + p2['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p2['title'].replace('"','') +'")');
       }
        catch(err){
         // console.log(err);
        }

        try{
        thirdIMG.src = p3['imageUrl'];
        thirdTitle.innerHTML = p3['title'];
        thirdPrice.innerHTML = '$' + p3['price'].toFixed(2);
        thirdContainer.setAttribute('onclick', 'logAndRedirect("' + p3['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p3['title'].replace('"','') +'")');
        }
        catch(err){
         // console.log(err);
        }
       // thirdContainer.classList.remove('loading-skeleton');
       // thirdTextContainer.classList.remove('loading-skeleton');
        try{
        fourthIMG.src = p4['imageUrl'];
        fourthTitle.innerHTML = p4['title'];
        fourthPrice.innerHTML = '$' + p4['price'].toFixed(2);
        fourthContainer.setAttribute('onclick', 'logAndRedirect("' + p4['onlineStoreUrl'] + '", "trending-'+ type + '", "' + p4['title'].replace('"','') +'")');
}
        catch(err){
         // console.log(err);
        }
        // thirdContainer.classList.remove('loading-skeleton');



        document.querySelectorAll('#SkeletonPlaceholder').forEach(el => el.classList.remove('skeleton_text'));
        document.querySelectorAll('.loading-skeleton').forEach(el => el.classList.remove('loading-skeleton'));

    }




}



async function getTrendingProductTypes(sku) {
    const url = `https://api.ombligo.com/getTrendingProducts`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const parsedData = JSON.parse(data);
        presentedData = {};
        for (item in parsedData){
            if (presentedData[item] == undefined){

              replaceProductTypeCards(item, parseResponseData(parsedData[item]));
              presentedData[item] = parseResponseData(parsedData[item]);
            }
        }
        
        //replaceProductCards(parseResponseData(parsedData));
        return parsedData;
    } catch (error) {
        console.error('Likely No data to pull ', error);
    }
}



const dots = document.querySelectorAll('.dot');
let blinkInterval;

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function blinkDot(dot) {
    const opacity = getRandomInt(0, 1);
    dot.style.opacity = opacity;
}

function blinkDotsRandomly() {
    dots.forEach(dot => {
        setTimeout(() => {
            blinkDot(dot);
            setTimeout(() => {
                dot.style.opacity = 1;
            }, 750);
        }, getRandomInt(1000, 3000));
    });
}

heroRight.addEventListener('mouseover', function() {
    blinkInterval = setInterval(blinkDotsRandomly, 150); 
});

heroRight.addEventListener('mouseout', function() {
    clearInterval(blinkInterval); 
    dots.forEach(dot => dot.style.opacity = 1);
});

function blinkLogRedirect() {
    blinkInterval = setInterval(blinkDotsRandomly, 150); 
    setTimeout(() => {
        dots.forEach(dot => dot.style.opacity = 1);  
        logAndRedirect('CTO', 'home', 'https://techmikeny.com/configure-to-order-servers');
    }, 200);
}

setInterval(() => {
    blinkDotsRandomly();
    setTimeout(() => {
        clearInterval(blinkInterval);
        dots.forEach(dot => dot.style.opacity = 1);
    }, 1000);
}, getRandomInt(5000, 30000));


